import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import _ from 'lodash';
import colorTheme from '../../../utils/color-theme';
import { RegularButton } from '../../button';
import ScaledText from '../../scaled-text';
import { COLORS } from 'src/theme';

const fontFamily = 'Lato, sans-serif';

const defaultStyles = StyleSheet({
  panorama: {
    border: 'solid 1px darkgray',
    overflow: 'hidden',
    flexGrow: 0,
    flexShrink: 0
  },
  shortHeadline: {
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: '300',
    fontFamily
  },
  img: {
    objectFit: 'cover'
  },
  content: {
    backgroundColor: 'white'
  },
  logoWrapper: {},
  footerLogo: {
    maxWidth: 'calc(0.75 * 146px)',
    maxHeight: 'calc(0.4 * 120px)',
    objectFit: 'contain'
  }
});

const buttonStyles = StyleSheet({
  button: {
    width: '146px'
  }
});

@styled(defaultStyles)
class Panorama extends PureComponent {
  static propTypes = {
    brandColor: PropTypes.string,
    shortHeadline: PropTypes.string,
    primaryImageUrls: PropTypes.object,
    logoUrls: PropTypes.object
  };

  render() {
    const {
      brandColor,
      backgroundColor,
      shortHeadline,
      primaryImageUrls,
      logoUrls,
      styles: s
    } = this.props;

    const { brandColorBorder } = colorTheme(brandColor);

    return (
      <Box width={980} height={120} flexDirection='row' {...s('panorama')}>
        <img
          width={204}
          height={120}
          src={_.get(primaryImageUrls, ['crop.landscape', 'url'])}
          {...s('img')}
        />
        <Box
          flex={1}
          justifyContent='space-between'
          alignItems='center'
          padding='0px 20px'
          {...s('content')}
        >
          <ScaledText
            maxWidth={440}
            maxTextLines={2}
            maxFontSize={36}
            minFontSize={32}
            {...s.with('shortHeadline')({ color: COLORS.BLACK })}
          >
            {shortHeadline}
          </ScaledText>
          <RegularButton brandColor={brandColor} styles={buttonStyles}>
            Find out now
          </RegularButton>
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          padding='40px 0'
          width={146}
          {...s.with('logoWrapper')({
            backgroundColor: backgroundColor,
            borderLeft: brandColorBorder
          })}
        >
          <img src={_.get(logoUrls, 'original.url')} {...s('footerLogo')} />
        </Box>
      </Box>
    );
  }
}

export default Panorama;
